import React from "react";
import { Button } from "@/components/ui/button";
import { useI18n } from "@/contexts/I18nContext";

export default function LanguageToggle({ className = "" }) {
  const { lang, setLang } = useI18n();
  const next = lang === "fr" ? "en" : "fr";
  return (
    <Button
      variant="ghost"
      size="sm"
      className={`px-3 font-mono text-xs tracking-widest uppercase ${className}`}
      onClick={() => setLang(next)}
      data-testid="lang-toggle"
    >
      {lang}
    </Button>
  );
}
